import { render, staticRenderFns } from "./DiscountsApproved.vue?vue&type=template&id=22958eb6&lang=pug"
import script from "./DiscountsApproved.vue?vue&type=script&lang=js"
export * from "./DiscountsApproved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports